@for (row of rows(); track row; let last = $last) {
  <div
    class="tw-flex tw-w-full tw-flex-col tw-gap-2 tw-py-3"
    [ngClass]="{
      'tw-border-b tw-border-gray-700': !last && variant() === 'dark',
      'tw-border-b tw-border-gray-200': !last && variant() === 'light'
    }"
  >
    <div class="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2">
      <ngx-skeleton-loader [theme]="dateTheme()"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="badgeTheme()"></ngx-skeleton-loader>
    </div>
    <div class="tw-pl-3.5">
      <ngx-skeleton-loader [theme]="byTheme()"></ngx-skeleton-loader>
    </div>
  </div>
}
